import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { FullTable, SelectActions } from 'components';
import { FindSuccessItem, Images, PermissionList, RolePermission, useModal } from 'utils';
import { httpRequestsOnSuccessActions, staffPayrollActions } from 'store';
import { activePayrollBody, activePayrollHead, ACTION_TYPE, activePayrollNotYet, timeSheetTabEnums } from './constants';

const ACTION_TYPE_SUCCESS = 'CREATE_TIMESHEET';
const ACTION_TYPE_EDIT_SUCCESS = 'EDIT_TIMESHEET';
const PROCESS_TIMESHEET = 'CREATE_PROCESS_PAYROLL';
export const ActivePayroll = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const activePayrolls = useSelector((state) => state?.staffPayroll?.activePayroll);
    const { close } = useModal();
    const success = FindSuccessItem(ACTION_TYPE_SUCCESS);
    const editSuccess = FindSuccessItem(ACTION_TYPE_EDIT_SUCCESS);
    const process = FindSuccessItem(PROCESS_TIMESHEET);
    const [selectedList, setSelectedList] = useState([]);
    const [selectAllList, setSelectAllList] = useState(false);

    const renderParams = () => {
        const filteredInfo = {
            ...info,
            // startDate: info?.start,
            // endDate: info?.end,
        };
        filteredInfo.skip = info?.skip ? info?.skip : 0;
        filteredInfo.limit = 50;
        delete filteredInfo.page;
        delete filteredInfo.activeTab;
        delete filteredInfo.staffFull;
        delete filteredInfo.start;
        delete filteredInfo.end;

        info?.start ? (filteredInfo.startDate = info?.start) : delete filteredInfo.startDate;
        info?.end ? (filteredInfo.endDate = info?.end) : delete filteredInfo.endDate;

        // if (info?.staffs?.length) {
        //     filteredInfo.staffs = info?.staffs?.map((i) => i.id);
        // } else {
        //     delete filteredInfo.staffs;
        // }

        return filteredInfo;
    };

    const getTimeSheet = (load) => {
        dispatch(staffPayrollActions.getActivePayroll({ ...renderParams() }, load));
    };

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_SUCCESS));
            getTimeSheet('noLoad');
            close();
        }
        if (editSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_EDIT_SUCCESS));
            getTimeSheet('noLoad');
            close();
        }
        if (process) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(PROCESS_TIMESHEET));
            getTimeSheet('noLoad');
            setSelectedList([]);
        }
    }, [success, editSuccess, process]);

    useEffect(() => {
        getTimeSheet();
    }, [info]);

    // const handleProcess = () => {
    //     if(RolePermission([PermissionList.TIMESHEET_PROCESS?.code])) {
    //         open(<ProcessModal />)
    //     }
    // };

    const afterSuccess = () => {
        getTimeSheet('noLoad');
    };

    const handleCheck = (ev, item, name) => {
        ev.stopPropagation();
        ev.preventDefault();
        setSelectAllList(false);

        if (name === 'all') {
            // setSelectedList(activePayrolls?.timesheets?.map((i) => i?.id));
            setSelectedList(
                activePayrolls?.timesheets?.length === selectedList?.length ? [] : activePayrolls?.timesheets?.map((i) => i?.id)
            );
        } else {
            setSelectedList((prev) => (prev.includes(item?.id) ? prev.filter((id) => id !== item?.id) : [...prev, item?.id]));
        }
    };

    const removeSelectedList = () => {
        setSelectedList([]);
        setSelectAllList(false);
    };

    return (
        <div>
            {!!selectedList?.length && (
                <SelectActions
                    actionType={PROCESS_TIMESHEET}
                    selectedList={selectAllList ? activePayrolls?.count : selectedList?.length}
                    selectAll={() => {
                        if (selectAllList) {
                            removeSelectedList();
                        } else {
                            setSelectAllList(true);
                            setSelectedList(activePayrolls?.timesheets?.map((i) => i?.id));
                        }
                    }}
                    submitText={'Process Payroll'}
                    selectInnetText={selectAllList ? 'Clear Selection' : ` Select all ${activePayrolls?.count} across all pages`}
                    submitBtnIcon={Images.addCircle}
                    submitClaims={() =>
                        dispatch(
                            staffPayrollActions.createProcessPayroll(
                                {
                                    timesheetIds: selectAllList ? [] : selectedList,
                                    all: selectAllList,
                                },
                                renderParams()
                            )
                        )
                    }
                    removeSelected={removeSelectedList}
                    submitPermission={RolePermission([PermissionList.PAYROLL_MANAGE?.code])}
                />
            )}
            <FullTable
                head={activePayrollHead(handleCheck, activePayrolls?.timesheets, selectedList, selectAllList)}
                body={activePayrollBody(afterSuccess, handleCheck, selectedList, selectAllList)}
                loadingType={ACTION_TYPE}
                list={activePayrolls?.timesheets}
                listCount={activePayrolls?.count}
                handleClick={(id) => navigate(`/timesheet/${id}`, { state: { tabType: timeSheetTabEnums.ACTIVE } })}
                notYet={activePayrollNotYet}
                activeRowId={''}
                detailPage={(item) => `/timesheet/${item?.id}`}
                selectedList={selectedList}
                selectAllList={selectAllList}
                margin={'12px 0 0 0'}
            />
        </div>
    );
};
